import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Switch, Route, withRouter } from "react-router-dom";
import axios from "axios";
import Cookie from "js-cookie";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Loader from "../components/Loader/index";
import Sidebar from "../components/Sidebar";
import Breadcrumb from "../components/Breadcrumb";
import Stats from "../containers/Stats";
import { Container } from "reactstrap";

import Categories from "../containers/Categories";
import CategoryForm from "../containers/CategoryForm";

import Users from "../containers/Users";
import UserForm from "../containers/UserForm";

import SpecialOffers from "../containers/SpecialOffers";
import SpecialOffersForm from "../containers/SpecialOffersForm";

import Popular from "../containers/Popular";
import PopularForm from "../containers/PopularForm";

import GalleryForm from "../containers/GalleryForm";
import Gallery from "../containers/Gallery";

import BannerForm from "./BannerForm";
import Banner from "./Banner";

import OrderForm from "../containers/OrderForm";
import Orders from "../containers/Orders";

import Notifications from "./Notifications";
import NotificationsForm from "./NotificationsForm";

import Items from "./Items";
import ItemsForm from "./ItemsForm";

import Extras from "./Extras";
import ExtrasForm from "./ExtrasForm";

import Locations from "./Locations";
import LocationsForms from "./LocationsForms";

import Brands from "./Brands";
import BrandForm from "./BrandForm";

import Videos from "./Videos";
import VideoForm from "./VideoForm";

import Properties from "./Properties";
import PropertyForm from "./PropertyForm";

import Blogs from "./Blogs";
import BlogsForm from "./BlogsForm";
class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      user: null,
      displayLoading: true,
      displayApp: false,
      displayMessage: "Loading User Data...",
    };
  }

  subscribeUserToPush() {
    // API-Aufruf, um den VAPID Public Key abzurufen
    console.log("API-Aufruf");

    // Verwenden von Axios, um den VAPID Public Key zu bekommen
    axios
      .post(
        "https://api.murat-lamm.de/api/notifications/generate-vapid-key/",
        {}
      )
      .then((response) => {
        const vapidPublicKey = response.data.publicKey; // Extrahiere den Public Key
        console.log("VAPID Public Key:", vapidPublicKey);

        // Konvertiere den Public Key in das erforderliche Format
        const applicationServerKey = this.urlB64ToUint8Array(
          "BH26mQCavw-Sz_E4zkRpHtVfesNoBm4_zwikrvhqFtn94guZLmvILCWOdCQOyrsYAM_Z3e2Ivwd7BBM9hTUTFCE"
        );

        // Service Worker bereit und Push-Abonnement durchführen
        navigator.serviceWorker.ready
          .then((registration) => {
            // Überprüfe, ob bereits eine Subscription existiert
            registration.pushManager.getSubscription().then((subscription) => {
              // Wenn der Benutzer bereits abonniert ist, abmelden und dann erneut anmelden
              if (subscription) {
                subscription.unsubscribe().then(() => {
                  console.log("Benutzer erfolgreich abgemeldet.");
                  // Nachdem der Benutzer abgemeldet wurde, erneut abonnieren
                  this.subscribeAgain(applicationServerKey); // Pfeilfunktion aufrufen
                });
              } else {
                // Wenn noch keine Subscription existiert, direkt abonnieren
                this.subscribeAgain(applicationServerKey); // Pfeilfunktion aufrufen
              }
            });
          })
          .catch(function (error) {
            console.log(
              "Fehler beim Abrufen der Service Worker-Registrierung:",
              error
            );
          });
      })
      .catch((error) => {
        console.error("Fehler beim Abrufen des Public VAPID Keys:", error);
      });
  }

  subscribeAgain = (applicationServerKey) => {
    navigator.serviceWorker.ready
      .then(function (registration) {
        return registration.pushManager.subscribe({
          userVisibleOnly: true, // Benachrichtigungen müssen sichtbar sein
          applicationServerKey: applicationServerKey, // Dein VAPID Public Key
        });
      })
      .then((subscription) => {
        console.log("Benutzer erfolgreich abonniert:", subscription);
        // Sende die Subscription an den Server
        this.sendSubscriptionToServer(subscription); // Methode korrekt aufgerufen
        navigator.serviceWorker.ready.then(function (registration) {
          registration.pushManager
            .getSubscription()
            .then(function (subscription) {
              if (!subscription) {
                // Subscription no longer exists, prompt user to re-subscribe
                console.log(
                  "Subscription is expired or has been unsubscribed."
                );
              } else {
                console.log("sub valid");
              }
            });
        });
      })
      .catch(function (error) {
        console.log("Fehler beim Abonnieren des Benutzers:", error);
      });
  };
  urlB64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
      .replace(/\-/g, "+")
      .replace(/_/g, "/");
    const rawData = atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }

  sendSubscriptionToServer(subscription) {
    console.log("subscirbetiosv");
    axios
      .post(
        "https://api.murat-lamm.de/api/notifications/save-admin-subscription",
        subscription,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        console.log(
          "Subscription erfolgreich an den Server gesendet!",
          response.data
        );
      })
      .catch((error) => {
        console.error(
          "Fehler beim Senden der Subscription an den Server:",
          error
        );
      });
  }

  componentWillMount() {
    const { dispatch, history } = this.props;

    // const token = Cookie.get("waffle_world_access_token");
    const token = localStorage.getItem("token");
    if (token) {
      // axios.defaults.headers.common.Authorization = `Bearer ${token}`;
      // axios.defaults.headers.common.Authorization = `${token}`;
      this.setState({ loading: false });
      if ("serviceWorker" in navigator) {
        console.log("versuche serviceworker zu registern");
        navigator.serviceWorker
          .register("/service-worker.js")
          .then(function (registration) {
            console.log(
              "Service Worker registriert in App.jsx:",
              registration.scope
            );
          })
          .catch(function (error) {
            console.log(
              "Fehler bei der Registrierung des Service Workers:",
              error
            );
          });
      }

      if ("Notification" in window && "serviceWorker" in navigator) {
        Notification.requestPermission().then((permission) => {
          if (permission === "granted") {
            console.log("Benachrichtigungsberechtigung erteilt");
            console.log("voraufrufapi");
            this.subscribeUserToPush();

            // Du kannst den Code hier fortsetzen, um den Benutzer zu abonnieren.
          } else {
            console.log("Benachrichtigungsberechtigung abgelehnt");
          }
        });
      }
      // this.setState({
      //   displayApp: true,
      //   displayLoading: false,
      //   loading: false,
      // })

      // To get currently signed in user

      // const requestParams = {
      //   "userId": localStorage.getItem("userId"),
      // }

      // axios.get(`${API_END_POINT}/api/users/one`, {params: requestParams})
      //   .then((response) => {
      //     dispatch({
      //       type: types.SET_USER_FROM_TOKEN,
      //       payload: response.data.object[0],
      //     });
      //   })
      //   .catch((error) => {
      //     this.setState({ loading: false });
      //   })

      // axios.get(`https://admin.saaditrips.com/api/user/me`)
      //   .then((response) => {
      //     // console.log("#### success", response.data);
      //     dispatch({
      //       type: types.SET_USER_FROM_TOKEN,
      //       payload: response.data,
      //     });
      //     this.setState({
      //       user: response.data,
      //       loading: false,
      //       displayApp: true,
      //       displayLoading: false,
      //     });
      //   })
      //   .catch((/* error */) => {
      //     // console.log("app componentWillMount error :: ", error);
      //     this.setState({ loading: false });
      //     Cookie.remove('saadi_admin_access_token');
      //     // history.push('/login');
      //     // window.location.replace('/login')
      //   });
    } else {
      this.setState({ loading: false, displayApp: true });
      history.push("/login");
      // window.location.replace('/login')
    }
  }

  render() {
    return (
      <div className="app">
        <Loader
          loading={this.state.loading}
          position={`fixed`}
          transparent={true}
        />
        <Header />
        <div className="app-body">
          <Sidebar {...this.props} user={this.state.user} />
          <main className="main">
            <Breadcrumb />
            <Container fluid>
              <Switch>
                <Route exact={true} path="/" component={Stats} />

                <Route exact={true} path="/categories" component={Categories} />
                <Route
                  exact={true}
                  path="/categories/category_form"
                  component={CategoryForm}
                />
                <Route
                  exact={true}
                  path="/categories/edit-category/:categoryId"
                  component={CategoryForm}
                />
                <Route
                  path="/categories/category/:categoryId"
                  component={Items}
                />
                <Route path="/orders/order/:orderId" component={Items} />

                <Route exact={true} path="/users" component={Users} />
                <Route
                  exact={true}
                  path="/users/user_form"
                  component={UserForm}
                />
                <Route
                  exact={true}
                  path="/users/edit_user/:userId"
                  component={UserForm}
                />

                <Route
                  exact={true}
                  path="/special-offers"
                  component={SpecialOffers}
                />
                <Route
                  exact={true}
                  path="/special-offers/specialOffer_form"
                  component={SpecialOffersForm}
                />
                <Route
                  exact={true}
                  path="/special-offers/edit_specialOffer/:specialOfferId"
                  component={SpecialOffersForm}
                />
                {/* ****** */}
                <Route exact={true} path="/blogs" component={Blogs} />
                <Route
                  exact={true}
                  path="/blogs/blogs_form"
                  component={BlogsForm}
                />
                <Route
                  exact={true}
                  path="/blogs/edit_blogs/:blogId"
                  component={BlogsForm}
                />

                <Route exact={true} path="/popular" component={Popular} />
                <Route
                  exact={true}
                  path="/popular/popular_form"
                  component={PopularForm}
                />
                <Route
                  exact={true}
                  path="/popular/edit_popular/:popularId"
                  component={PopularForm}
                />

                <Route
                  exact={true}
                  path="/notifications"
                  component={Notifications}
                />
                <Route
                  exact={true}
                  path="/notifications/notifications_form"
                  component={NotificationsForm}
                />
                <Route
                  exact={true}
                  path="/notifications/edit_notifications/:notificationId"
                  component={NotificationsForm}
                />

                <Route exact={true} path="/gallery" component={Gallery} />
                <Route
                  exact={true}
                  path="/gallery/cover_banner_form"
                  component={GalleryForm}
                />
                <Route
                  exact={true}
                  path="/gallery/edit_coverBanner/:coverBannerId"
                  component={GalleryForm}
                />
                <Route exact={true} path="/banner" component={Banner} />
                <Route
                  exact={true}
                  path="/banner/banner_form"
                  component={BannerForm}
                />
                <Route
                  exact={true}
                  path="/banner/edit_banner/:bannerId"
                  component={BannerForm}
                />

                <Route exact={true} path="/orders" component={Orders} />
                <Route
                  exact={true}
                  path="/orders/order_form"
                  component={OrderForm}
                />
                <Route
                  exact={true}
                  path="/orders/edit_order/:orderId"
                  component={OrderForm}
                />

                <Route exact={true} path="/items" component={Items} />
                {/* <Route exact={true} path="/items/:categoryId" component={Items}/> */}
                <Route
                  exact={true}
                  path="/items/edit_item/:itemId"
                  component={ItemsForm}
                />
                <Route
                  exact={true}
                  path="/items/items_form"
                  component={ItemsForm}
                />

                <Route exact={true} path="/extras" component={Extras} />
                {/* <Route exact={true} path="/items/:categoryId" component={Items}/> */}
                <Route
                  exact={true}
                  path="/extras/edit_extra/:itemId"
                  component={ExtrasForm}
                />
                <Route
                  exact={true}
                  path="/extras/extras_form"
                  component={ExtrasForm}
                />

                <Route exact={true} path="/locations" component={Locations} />
                {/* <Route exact={true} path="/items/:categoryId" component={Items}/> */}
                <Route
                  exact={true}
                  path="/locations/edit_location/:itemId"
                  component={LocationsForms}
                />
                <Route
                  exact={true}
                  path="/locations/locations_form"
                  component={LocationsForms}
                />

                <Route exact={true} path="/brands" component={Brands} />
                <Route
                  exact={true}
                  path="/brands/edit_brand/:brandId"
                  component={BrandForm}
                />
                <Route
                  exact={true}
                  path="/brands/brand_form"
                  component={BrandForm}
                />

                <Route exact={true} path="/videos" component={Videos} />
                <Route
                  exact={true}
                  path="/videos/edit_video/:videoId"
                  component={VideoForm}
                />
                <Route
                  exact={true}
                  path="/videos/video_form"
                  component={VideoForm}
                />

                <Route exact={true} path="/properties" component={Properties} />
                <Route
                  exact={true}
                  path="properties/property-form"
                  component={PropertyForm}
                />
                <Route
                  exact={true}
                  path="properties/edit-property/:pid"
                  component={PropertyForm}
                />
              </Switch>
            </Container>
          </main>
        </div>
        <Footer />
      </div>
    );
  }
}

App.propTypes = {
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  user: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

export default withRouter(connect(mapStateToProps)(App));



// WEBPACK FOOTER //
// ./src/containers/App.jsx